/*!
    * @product/scmp-sdk 1.0.191
    * 2ee70241639e6ca63aaacf31294551dd6dda7662
  */
import{h as t}from"./chunk-5KDKHJQC.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-KFZH4E6A.js.map
